const dict = {
  uk: {
    typeVacation: 'Відпустка',
    typeSick: 'Лікарняний',
    typeForceMajeure: 'Форсмажор',
    typeDayOff: 'Вихідний',
    requestTitle: 'Заявка',
    requestPrefix: 'Заявка: {{type}}',
    newRequest: 'Нова заявка',
    partialAbsence: 'Часткова відсутність (кілька годин на один день)',
    partialAbsenceHint: 'Треба відійти на годину-дві — не скасовуйте всі уроки на день. Рахується як 1 день ліміту.',
    startDate: 'Початок',
    endDate: 'Кінець',
    reasonOptional: 'Причина (опційно)',
    vacationRule: 'Відпустку треба подавати щонайменше за 14 днів. Доступний баланс рахується з моменту вашого першого уроку (1 тиждень / 6 місяців, кеп 2 тижні).',
    sickRule: 'Лікарняний — ліміт 10 днів на календарний рік. Заднім числом подати не можна.',
    forceMajeureRule: 'Форсмажор — ліміт 2 дні на календарний місяць. Невикористані згорають (не переносяться на наступний місяць). Заднім числом подати не можна.',
    dayOffRule: 'Вихідний треба подавати щонайменше за 7 днів. Ліміт — 2 вихідні на календарний місяць.',
    sickCardTitle: 'Лікарняне',
    sickCardSubtitle: 'Лікарняний або форсмажор',
    absenceRequestSection: 'Заявка на відсутність',
    vacationCardTitle: 'Відпустка',
    vacationCardSubtitle: 'Подавати щонайменше за 14 днів',
    sickComboTitle: 'Заявка: лікарняний / форсмажор',
    combinedCardSubtitle: 'Відпустка, лікарняний, форсмажор або вихідний',
  },
  en: {
    typeVacation: 'Vacation',
    typeSick: 'Sick leave',
    typeForceMajeure: 'Force majeure',
    typeDayOff: 'Day off',
    requestTitle: 'Request',
    requestPrefix: 'Request: {{type}}',
    newRequest: 'New request',
    partialAbsence: 'Partial absence (a few hours on one day)',
    partialAbsenceHint: 'Need to step out for an hour or two — do not cancel all lessons for the day. Counts as 1 day of the limit.',
    startDate: 'Start',
    endDate: 'End',
    reasonOptional: 'Reason (optional)',
    vacationRule: 'Vacation must be requested at least 14 days in advance. Available balance accrues from the date of your first lesson (1 week / 6 months, cap 2 weeks).',
    sickRule: 'Sick leave — limit of 10 days per calendar year. Cannot be submitted retroactively.',
    forceMajeureRule: 'Force majeure — limit of 2 days per calendar month. Unused days expire (do not roll over). Cannot be submitted retroactively.',
    dayOffRule: 'A day off must be requested at least 7 days in advance. Limit — 2 day-offs per calendar month.',
    sickCardTitle: 'Sick leave',
    sickCardSubtitle: 'Sick leave or force majeure',
    absenceRequestSection: 'Absence request',
    vacationCardTitle: 'Vacation',
    vacationCardSubtitle: 'Request at least 14 days in advance',
    sickComboTitle: 'Request: sick leave / force majeure',
    combinedCardSubtitle: 'Vacation, sick leave, force majeure, or day off',
  },
};

export default dict;
